import React, { useState } from "react";
import Image from "../elements/Image";
import Button from "../form/front/Button";
import { classNames } from "../../helpers/classNames";

const SingleCompanyCard = ({ data, onClick, isSelected }) => {
  const [isSaved, setIsSaved] = useState(false);
  // const [isSelected, setIsSelected] = useState(false);

  const checkboxId = `job-card-${data?.id}`;

  return (
    <div className="relative">
      <input
        type="checkbox"
        id={checkboxId}
        checked={isSelected}
        onChange={() => onClick(data)}
        className="peer hidden"
      />

      <label
        htmlFor={checkboxId}
        className={classNames(
          "flex-shrink flex-grow border rounded-2xl py-6 px-6 flex md:flex-row flex-col items-start gap-5 relative shadow-md transition-all duration-300 cursor-pointer",
          isSelected
            ? "border-palatte5 dark:border-gray-200 dark:bg-gray-200/15"
            : "border-palatte3 dark:border-gray-500 hover:border-palatte dark:bg-gray-200/5",
        )}
      >
        {data?.logo && (
          <div className="w-11 rounded-md aspect-square overflow-hidden flex-shrink-0">
            <Image src={data.logo} alt={data.name} classes="object-contain" />
          </div>
        )}

        <div className="flex-shrink flex-grow space-y-2 pr-0 xls:pr-32">
          {data.name && (
            <div className="text-black dark:text-gray-100 text-base capitalize font-bold line-clamp-2">
              {data.name}
            </div>
          )}

          {data?.description && (
            <div
              className="text-sm text-slate-500 dark:text-gray-300 space-y-1 line-clamp-3"
              dangerouslySetInnerHTML={{ __html: data?.description }}
            />
          )}

          <div className="mt-auto">
            <span className="bg-purple-100 text-purple-700 text-sm font-semibold px-3 py-1 rounded-full">
              {data.jobCount} {data.jobCount === 1 ? "Job" : "Jobs"}
            </span>
          </div>
        </div>

        {/* <div className="absolute right-6 top-4">
          <Button
            buttonLabel="save job"
            buttonLabelClasses="capitalize text-sm font-semibold group-hover:text-white"
            buttonIcon={
              isSaved ? "fa-solid fa-bookmark" : "fa-regular fa-bookmark"
            }
            buttonIconPosition="right"
            buttonFunction={() => {
              if (!isSelected) {
                setIsSaved((prev) => !prev);
              }
            }}
            buttonClasses={classNames(
              "h-9 border border-palatte4 text-sm group transition-all",
              isSaved
                ? "bg-palatte4 text-white"
                : "bg-white text-palatte4 hover:bg-palatte4 hover:text-white",
            )}
          />
        </div> */}
      </label>
    </div>
  );
};

export default SingleCompanyCard;
